"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const TESTIMONIAL_IMAGES = [
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Hadeesa.webp",
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Ramiz.webp",
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IqraFatima.webp", // 3rd link check karein
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Moazzam.webp",
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Sajid.webp",
];

const ZaynTestimonialsSection = () => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    const testimonials = t("zaynTestimonials.items", { returnObjects: true }) || [];

    return (
        <Box
            sx={{
                py: { xs: 5, sm: 6, md: 8 },
                direction: isArabic ? "rtl" : "ltr",
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    sx={{
                        fontSize: { xs: "11px", sm: "12px" },
                        fontWeight: 600,
                        color: "#7A2BF5",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        fontFamily: "var(--font-outfit)",
                        textAlign: "center",
                        mb: { xs: 1, sm: 1.5 },
                    }}
                >
                    {t("zaynTestimonials.label")}
                </Typography>

                <Typography
                    variant="h2"
                    sx={{
                        fontSize: { xs: "24px", sm: "28px", md: "32px" },
                        fontWeight: 700,
                        lineHeight: 1.3,
                        color: "#14122B",
                        fontFamily: "var(--font-plusjakarta)",
                        textAlign: "center",
                        mb: { xs: 3, sm: 4, md: 5 },
                    }}
                >
                    {t("zaynTestimonials.title")}
                </Typography>

                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
                        gap: { xs: 2, sm: 2.5, md: 3 },
                    }}
                >
                    {testimonials.map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                bgcolor: "#F4F1FC",
                                borderRadius: "16px",
                                p: { xs: 2.5, sm: 3 },
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                textAlign: isArabic ? "right" : "left",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: { xs: "13px", sm: "14px" },
                                    color: "#3D3D52",
                                    lineHeight: 1.7,
                                    fontWeight: 400,
                                    fontFamily: "var(--font-outfit)",
                                    mb: { xs: 2.5, sm: 3 },
                                }}
                            >
                                {item.quote}
                            </Typography>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1.5,
                                }}
                            >
                                <Box>
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "13px", sm: "14px" },
                                            fontWeight: 700,
                                            color: "#14122B",
                                            fontFamily: "var(--font-plusjakarta)",
                                        }}
                                    >
                                        {item.name}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "11px", sm: "12px" },
                                            color: "#65657A",
                                            fontFamily: "var(--font-outfit)",
                                        }}
                                    >
                                        {item.role}
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        position: "relative",
                                        width: 40,
                                        height: 40,
                                        borderRadius: "50%",
                                        overflow: "hidden",
                                        flexShrink: 0,
                                    }}
                                >
                                    <img
                                        src={TESTIMONIAL_IMAGES[index]}
                                        alt={item.name}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            objectPosition: "top",
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    ))}

                    {/* Rating highlight card */}
                    <Box
                        sx={{
                            backgroundImage:
                                "url(https://getgeek-website-assets.b-cdn.net/GradientTestimonialZayn.webp)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            bgcolor: "#7A2BF5", // image load hone tak fallback color
                            borderRadius: "16px",
                            p: { xs: 2.5, sm: 3 },
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            color: "#fff",
                            textAlign: isArabic ? "right" : "left",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: { xs: "28px", sm: "32px" },
                                fontWeight: 700,
                                fontFamily: "var(--font-plusjakarta)",
                                mb: 0.5,
                            }}
                        >
                            {t("zaynTestimonials.ratingValue")}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: { xs: "13px", sm: "14px" },
                                fontWeight: 400,
                                fontFamily: "var(--font-outfit)",
                                opacity: 0.9,
                            }}
                        >
                            {t("zaynTestimonials.ratingCaption")}
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default ZaynTestimonialsSection;